import { useQuery } from '@tanstack/react-query';
import { UsersApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useUsersQueryControllerFindAllUsersQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['usersQueryControllerFindAllUsers', accessControlScope, args],
        queryFn: async () => {
            const api = new UsersApi(accessControlConfig);
            return api.usersQueryControllerFindAllUsers(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useUsersQueryControllerFindAllUsersQuery.js.map